import React from "react";
import moment from 'moment';
import Checkbox from "components/Checkbox/Checkbox";

export default {
    TABLE: {
        className: "data-table-important-documents",
        initialSortKey: "document_name",
        initialSortOrder: "asc"
    },

    COLUMN: [
        {
            label: "Document Name",
            header: "DOCUMENT NAME",
            key: "document_name",
            sortable: true,
            className: "document-name",
            format: ({ rowData, customTableProps }) => {
                let icon = '';

                if (rowData['file_type'] === 'text'){
                    if (rowData['document_name'].endsWith(".pdf")){
                        icon = <i className="fas fa-file-pdf"></i>
                    }else{
                        icon = <i className="fas fa-file-word"></i>
                    }
                }

                if (rowData['file_type'] === 'spreadsheet'){
                    icon = <i className="fas fa-file-excel"></i>
                }

                if (rowData['file_type'] === 'presentation'){
                    icon = <i className="fas fa-file-powerpoint"></i>
                }


                return <span>{icon} {rowData["document_name"]}</span>;
            }
        },
        {
            label: "Created",
            header: "CREATED",
            key: "last_modified",
            sortable: true,
            className: "created",
            format: ({ rowData, customTableProps }) => {
                return <span>{ moment(rowData["last_modified"]).format("MM/DD/YYYY")}</span>;
            }
        },
        {
            label: "Understood",
            header: "UNDERSTOOD",
            key: "understood",
            sortable: true,
            className: "revised",
            format: ({ rowData, customTableProps }) => {

                    if (rowData.requires_attest === true) {

                        return <Checkbox
                                checked={rowData["understood"]}
                                onChange={() => customTableProps.attest(rowData)}
                                name="row-selector"
                                />;
                }
                return false;
            }
        }
    ]
};
